module.exports = __webpack_public_path__ + "static/media/badge-macos.11312f31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/badge-macos.png
// module id = 84
// module chunks = 0